import { styled } from '@mui/material/styles'
import { Box, BoxProps } from '@mui/material'
import { Content } from '@/components/ui'

import logo from '@/images/logo-black.png'
import loginBackgroundImage from '@/images/login-background.jpg'
import Image from 'next/image'
import React from 'react'

const BackgroundImage = styled(Image)`
  object-fit: cover;
`

const Logo = styled(Image)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const MobileContent = styled(Content)<BoxProps & { ref?: any }>`
  position: relative;

  ${({ theme }) => theme.breakpoints.only('xs')} {
    border-radius: 12px 12px 0 0;
    background-color: ${({ theme }) => theme.palette.common.white};
    top: -12px;
  }
`

interface Props {
  logoSize?: {
    width: number
    height: number
  }
  bgSize?: {
    height?: number
    top?: number
  }
}

export const MobileHeader: React.FC<Props> = ({ logoSize, bgSize }) => {
  const containerHeight = bgSize?.height || 84
  const logoWidth = logoSize?.width || 167
  const logoHeight = logoSize?.height || 36

  return (
    <Box sx={{ width: '100%', height: containerHeight, position: 'relative' }}>
      <BackgroundImage
        fill
        src={loginBackgroundImage}
        alt="Charleston Wrap mobile background"
        style={{ top: bgSize?.top }}
      />
      <Logo src={logo.src} alt="Charleston Wrap logo" width={logoWidth} height={logoHeight} />
    </Box>
  )
}
